/* eslint-disable import/prefer-default-export */
import api from './api';

const apiWithTags = api.enhanceEndpoints({
	addTagTypes: ['FlexLocations']
});

const flexProfessionalLocationsApi = apiWithTags.injectEndpoints({
	tagTypes: ['FlexLocations'],
	endpoints: (build) => ({
		flexLocations: build.query({
			query: ({ managementCompanyId, caregiverId }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/facilities`,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			providesTags: ['FlexLocations']
		}),
		updateLocationsStatus: build.mutation({
			query: ({ managementCompanyId, caregiverId, body }) => ({
				url: `/flex/management-companies/${managementCompanyId}/caregivers/${caregiverId}/facilities`,
				method: 'PUT',
				body,
				headers: {
					'management-company-id': managementCompanyId
				}
			}),
			invalidatesTags: ['FlexLocations']
		})
	})
});

export const { useFlexLocationsQuery, useUpdateLocationsStatusMutation } = flexProfessionalLocationsApi;
